/* A third-party popup app (react-responsive-modal, used by the email opt-in widget) leaves its
   dialog mounted in the DOM at all times, centered on the page, even while fully closed
   (opacity: 0). That dialog keeps `pointer-events: auto` in its closed state, so any click that
   lands in that centered region — including the product card add-to-cart button when it happens
   to fall there — is swallowed by the invisible dialog instead of reaching the real element
   underneath. This polls the dialog's rendered opacity and only allows it to receive clicks while
   it's actually visible, without touching the app's own open/close logic. */
(function () {
  function guard(root) {
    if (root.__clickGuarded) return;
    root.__clickGuarded = true;

    var modal = root.querySelector('.react-responsive-modal-modal');
    if (!modal) return;

    function sync() {
      // The root (fixed, full-viewport, on top of everything) and its container both keep
      // default pointer-events regardless of the modal's own opacity, so gating just the modal/
      // overlay children isn't enough — the root itself still catches clicks meant for the page
      // behind it. Gate the root: pointer-events none while closed, auto while the dialog is
      // actually visible (its children keep their own default auto, so the real popup UI still
      // works normally once opacity confirms it's open).
      var visible = parseFloat(getComputedStyle(modal).opacity) > 0.05;
      root.style.pointerEvents = visible ? '' : 'none';
    }

    sync();
    modal.addEventListener('transitionend', sync);
    modal.addEventListener('animationstart', sync);
    modal.addEventListener('animationend', sync);
    setInterval(sync, 400);
  }

  function scan() {
    document.querySelectorAll('.react-responsive-modal-root').forEach(guard);
  }

  scan();
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
})();
